export default __webpack_public_path__ + "static/media/Resources.ab71457d.svg";